import React, { ReactElement } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Redirect } from 'react-router'
import useInitHook from '../hooks/useInitHook'
import { DefaultTemplate } from './templates'
import { IStore } from '../interfaces/Store'
import { ROUTES } from '../enums/routes'
import Step1 from '../components/step1/Step1'
import Step2 from '../components/step2/Step2'
import Step3 from '../components/step3/Step3'
import Step4 from '../components/step4/Step4'
import Step5 from '../components/step5/Step5'
import Step6 from '../components/step6/Step6'
import { isLoggedIn } from '../services/utils'
import {
  JOURNEY_COMPLETE_STATUSES,
  JOURNEY_REACCESS_STATUS,
  STATUS,
} from '../enums/common'
import Spinner from '../components/Spinner'
import { shouldDeleteDocumentsActions } from '../store/slices/DeleteDocuments'

const Home = (): ReactElement => {
  document.title = 'Louvre Banque Privée - Mise à jour du dossier'
  const { status } = useInitHook()
  const { breadcrumb, step } = useSelector(
    (state: IStore) => state.breadcrumbReducer
  )
  const {
    status: folderStatus,
    folder: { journeyStatus },
  } = useSelector((stateReducer: IStore) => stateReducer.folderReducer)
  const dispatch = useDispatch()

  if (!isLoggedIn()) {
    return <Redirect to={ROUTES.unauthorized} />
  }
  // Disable the deletion of the non valid documents with (status < 8) unless it is the first step
  if (step !== 0 || (step === 0 && JOURNEY_REACCESS_STATUS === journeyStatus)) {
    dispatch(shouldDeleteDocumentsActions.setShouldDeleteDocuments(false))
  }

  const title: string = breadcrumb[step]?.titre
  const stepProps = { step, status, title }
  const getStep = () => {
    switch (step) {
      case 0:
        return <Step1 {...stepProps} />
      case 1:
        return <Step2 {...stepProps} />
      case 2:
        return <Step3 {...stepProps} />
      case 3:
        return <Step4 {...stepProps} />
      case 4:
        return <Step5 {...stepProps} />
      case 5:
        return <Step6 {...stepProps} />
      default:
        return <Redirect to={ROUTES.pageNotFound} />
    }
  }

  if (folderStatus !== STATUS.loaded) {
    return (
      <DefaultTemplate>
        <div className="relative pb3 pl3 mb3">
          <Spinner />
        </div>
      </DefaultTemplate>
    )
  }

  if (
    status === STATUS.loaded &&
    JOURNEY_COMPLETE_STATUSES.includes(journeyStatus)
  ) {
    return <Redirect to={ROUTES.confirmationPage} />
  }

  return <DefaultTemplate>{getStep()}</DefaultTemplate>
}

export default Home
